

export class AgentQuestions{
    static QuestionsForAgent = [
     'Do you prefer lending money to family member only?',
     `Are you good at making sure small details are not overlooked?`,
      `Do you work at your own pace instead of the task's required time?`,
      'Do you prefer to work alone?',
     'Government grant is often considered free money, would you pay back if government gives you a credit facility?',
    'Family bond seems to be getting weaker these days that we find it harder to help ourselves. Would you consider your friends and family first if you are in charge of grant disbursement?',
    'Are you obsessed with luxurious fashion items?',
    'Do you push yourself hard to succeed?',
    'Do you smile and laugh often?',
    'Do you lose your temper quickly but regain composure quickly?',
    'Are you a detailed oriented person?',
    'Have you ever volunteered for a cause?',
    'Social media is the ideal channel to expose those who do not agree with you. Do you agree?',
    'Social media is best to expose those who do not agree with us. Do you agree?',
    'Do you have difficulty starting a task?',
    'Have you ever suffered consequences of doing the right thing?',
    'Do others consider you to be trustworthy?',
    'Would you report a colleague who stole from the workplace because of financial struggle?',
    'Are you married?',
    'Have you taken loan from more than three lenders?',
    'Do you take alcohol?',
    'Do you believe most employers take advantage of the people who work for them?',
    'Have you ever had a dispute with your superior over fact?',
    'Have you ever earn money through ponzi scheme?',
    'Do you believe that taking paper or pen without permission from a place where you work is stealing?',
    'Irrespective of the resources at your disposal, would you always prefer to eat at expensive restaurants?',
    'Do you easily empathize with people even when they are wrong?',
    `Would you report your friend to the police if he/she steals other people's money to pay his/her child school fee?`,
    'Do you find it stressful when the goal changes within a task?',
    'When people make a mistake that you benefit from, do you correct them?',
    'Have you ever invested money made from betting on business that gives you return?',
    'The country is currently tensed. If you were given opportunity to relocate to the united state immidiatey, would you go?',
    `Is It better to get things done than staying quiet?.`, 
    `Have you ever fought your employer on behalf of your colleagues?`,
    `If you are left with someone else's money in an emergency situation, would you use the money first before telling the owner?`,
    `Nigeria is a very rich country that if every citizen get paid every month without working, we will still have money left. Do you agree?`,
    `Do you often consider selling your personal belonging when you are in need of money?`,
    `Do you have a favourite lottery company?`,
    `Use of marijuana has been scientifically proven to increase productivity, Would you consider taking it everyday to boost productivity?`,
    `People in power have been the major problem of Nigeria, invading their homes after they are convicted of corruption to take what belongs to the Nigerians will teach them a lesson. do you agree?`,
    `Family bond seems to be getting weaker these days that we find it harder to help ourselves. Would you consider your friends and family first if you are in charge of grant disbursement?`,
    `Are you less than 18 year old?`,
    `Are you more than 45 year old?`,
    `Do you prefer lending money to family member only?`,
    `Does social media platform help settle issues with those percieved to be superior than you?`,
    `Do you consider yourself an honest person?`,
     `Would you donate to church or mosque the money mistakingly paid into your account by government official?`,
     `Would you rather walk away from a task if you feel disrespected?`,
     `Do you have mood swings more often?`,
     `Do you work at your own pace instead of the task's required time?`,
     `Are you the kind of person who sees the big picture but focus less on small details?`,
     `Do you believe God can bless you by making you reap where others have sown?`, 
     `Do you like doing things you are not supposed and break the rules?`,
     `Do you believe God can take another person's wealth and give to you?`,
    `Do you find it hard to adapt to new situation?`,
    `Do you feel you are superior to others?`,
    `Do you postpone unappealing tasks?`,
    ]
}